import { Router } from '@angular/router';
import { Component, EventEmitter, HostListener, Inject, Input, OnInit, Output, TemplateRef, ViewChild, DOCUMENT } from '@angular/core';
import { TalentpoolService } from 'src/app/_services/talentpool.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import {SearchtoolboxService} from "../../_services/searchtoolbox.service";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateTalentpoolComponent } from '../create-talentpool/create-talentpool.component';
import { TransactionService } from 'src/app/_services/transaction.service';
import * as _ from 'underscore';
import { ShareTalentpoolsModalComponent } from 'src/app/share-talentpools-modal/share-talentpools-modal.component';

import { PersonSearchService } from 'src/app/_services/person-search.service';

declare const clevertap;

@Component({
    selector: 'app-talentpool-list',
    templateUrl: './talentpool-list.component.html',
    styleUrls: ['./talentpool-list.component.scss'],
    standalone: false
})
export class TalentpoolListComponent implements OnInit {

  talentpools: any[] = [];
  candidatecount: any;
  start: number = 0;
  end: any;
  isSearchHistoryPresent: boolean = false;
  isExtensionInstalled: boolean = false;
  isAlteastOneBasicContactEnrichmentCreditUsed: boolean =  false;
  isSkippedTalentPool: boolean = false;
  successMessage: string;
  errorMessage: string;
  subscriptiondetails: any = {}
  isteamMember: boolean;
  sortby: string = ""
  talentdetails: any
  selected: boolean;
  selectedtalentpools: any =[]
  selectedTalentpools: any[] = [];
  talentpoolname: string = ''
  talentpoolscount: any
  @ViewChild('noCreditTalentpool') noCreditTalentpool: TemplateRef<any>;
  @ViewChild('deleteTalentpoolmodal') deleteTalentpoolmodal: TemplateRef<any>;
  @Output() talentooolEvent: EventEmitter<any> = new EventEmitter();
  showSearchLoader:boolean=false
  showLoader: boolean = true;
  @Input() hideTalenpooltSearchSection: boolean = false;
  talentpoolHeaders = ['Talentpool Name', 'Talent Count', 'Recommended Matches', 'Last Updated', 'Actions'];

  pageNumber: number = 1;
  currentPage: number = 1;
  profilesPerPage: number = 10;

  isScrolled: boolean = false;
  private readonly scrollThreshold = 55;
  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const verticalOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    this.isScrolled = verticalOffset >= this.scrollThreshold;
  };

  constructor(private router : Router , public talentpoolservice : TalentpoolService ,private _localstorageservice : LocalStorageService, public searchtoolservice: SearchtoolboxService,
    private modalService: NgbModal,private transactionservice:TransactionService,
    private personSearchService: PersonSearchService,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit() {
    const preferenceArray = this._localstorageservice.getItem('userdata').preferenceData;
    preferenceArray && preferenceArray.length && preferenceArray.map(item => {
      if (item.listing_type == 'talentpool-list' && item.preference_type == 'page-size') {
        this.profilesPerPage = item.preference_value;
      }
    })

    this.talentpoolservice.GetCreatedTalentpoolData().subscribe(event => {
    })
    this.talentpoolservice.talentPoolDetails.subscribe((talentPoolData) => {
      if(typeof talentPoolData == 'object' && Object.keys(talentPoolData).length) {
          this.talentpools = talentPoolData.talentpools || [];
          this.talentpoolscount = talentPoolData?.talentpoolcount;
          this.candidatecount = talentPoolData.allcandidatescount;
      }
    });
    this.talentpools = this.talentpools ? this.talentpools.map(tp => ({ ...tp, selected: false })) : [];
    this.getTalentpoolList()
    // this.checkSearchToolboxHistoryIsPresent()
    // this.sendMessagetoChrome()
    // this.checkIfAtLeastOneBasicContactEnrichmentCreditIsUsed()
    // this.isSkippedTalentPool = !!this._localstorageservice.getItem('SKIP_TALENT_POOL')
  }

  getTalentpoolList(){
    this.showSearchLoader=true
    this.talentpoolservice.getTalentpoolList(this._localstorageservice.getItem('usernumber'),this.sortby, this.talentpoolname, this.start, this.profilesPerPage).subscribe((res:any)=>{
      this.showLoader = false;
      if(res.status =="success"){
        const talentPoolDetails = res?.data;
        if(this.sortby || this.talentpoolname) {
          talentPoolDetails['isfilter'] = true;
        }
        this.talentpoolservice.setTalentPoolCount(talentPoolDetails || null);
        !this.sortby && !this.talentpoolname && this.talentpoolservice.setTalentPoolDetails(talentPoolDetails || null);
        !this.sortby && !this.talentpoolname && this._localstorageservice.setItem('talentPoolDetails', JSON.stringify(res?.data) || null);
      this.showSearchLoader=false
        this.talentpools = res.data && res.data.talentpools ? res.data.talentpools : []
        // this.talentpoolscount = this.talentpools.length
        this.talentpoolscount = res.data.talentpoolcount
        this.candidatecount = res.data.allcandidatescount
      }
    }, () => {
      this.showLoader = false;
    })

  }

  OpenCandidateList(type){
    if(type == 'all'){
      this.router.navigateByUrl("/candidate-list")
    }
    else{
      let talentpoolid = type.talentpoolid
      this.router.navigate(['talentpool/details/'+ talentpoolid])
    }
  }

  /**
   *  Check if atleast 1 search is performed on Search Toolbox
   */
  // checkSearchToolboxHistoryIsPresent(){
  //   let data ={
  //     "startindex":this.start,
  //     "usernumber": this._localstorageservice.getItem('usernumber')
  //   }
  //   this.searchtoolservice.fetchsearchtoolboxhistory(data).subscribe(({data}:any)=>{
  //     this.isSearchHistoryPresent = data.searchhistoryrecords.length !== 0;
  //   })
  // }

  /**
   * Check if  the Chrome Extension is Installed or not
   */
  sendMessagetoChrome() {
    let chromeid = localStorage.getItem('extensionID');
    if (chromeid) {
      try {
        window['chrome'].runtime.sendMessage(chromeid, { action: 'getSimilarCandidateResult' }, (res)=> {
          if (res.similarCandidateData) {
            this.isExtensionInstalled  = true
          }
        });
      } catch (error) {
        if (error) {
          this.isExtensionInstalled  = false
        }
      }
    }
  }

  /*
  * Check whether User has used 1 basic contact enrichment credit on any candidate
  */
 checkIfAtLeastOneBasicContactEnrichmentCreditIsUsed(){
    let userdata = this._localstorageservice.getItem('userdata');
    this.isAlteastOneBasicContactEnrichmentCreditUsed = userdata.balancebasiccontactenrichmentcredits !== 10
 }

  /**
   * Skip Talentpool based on user session
   */
  skipTalentPoolBanner(){
    this._localstorageservice.setItem('SKIP_TALENT_POOL',"true")
    this.isSkippedTalentPool = true
  }

  /**
   * Redirect to Search Toolbox
   */
  redirectToSearchToolbox(){
    this.router.navigateByUrl("/searchtoolbox-v2")
  }

  extractFirstTime(){
    this.router.navigateByUrl('/searchtoolbox-v2?first-extract=true')
  }

  createTalentpool() {
    // if(this._localstorageservice.getItem('tpcredits') > 0){
      const modalRef = this.modalService.open(CreateTalentpoolComponent, { size: 'lg' as 'lg', backdrop: 'static', keyboard: false ,centered: true,});
      modalRef.componentInstance.passEntry.subscribe((x) => {
        if (x == 'talentpool-added') {
          this.toastmessage('Talentpool Created Succesfully', 'success')
          this.fetchcredits()
          this.getTalentpoolList();
      } else if(x == 'talentpool-edited') {
        this.toastmessage('Talentpool Edited Succesfully', 'success')
        this.fetchcredits()
        this.getTalentpoolList();
      }
      // else if(x == 'notpcredits'){
      //   const modalRef = this.modalService.open(this.noCreditTalentpool,{ windowClass: "myCustomModalClass", centered: true });
      //   this.sendmailexpiry('Talent Pipeline credits')
      // }
      else if(x =='error'){
        this.toastmessage('Something went wrong, Please try again in a minute', 'error')
      }})
      // }else{
      //   let clevertap_data = {
      //     "Talent Pool Name" : 'null',
      //   }
      //   this.cleverTapEvent("TalentPool_CreditExpiry", clevertap_data);
      //   const modalRef = this.modalService.open(this.noCreditTalentpool,{ windowClass: "myCustomModalClass", centered: true });
      //   this.sendmailexpiry('Talent Pipeline credits')
      // }
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }

  fetchcredits(){
    // Credits come from the shared signal (populated only on login and after reveal-contact
    // succeeds, see TransactionService) - no direct call to /paymentflow/fetchcurrentplancredits.
    const res: any = { data: this.transactionservice.credits() };
    if (res.data) {
        if (res.data.isteamadmin) {
          // Here the logged in person is a Team Admin
          this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
          this.subscriptiondetails.balancejdparsingcredits = res.data.pooledbalancejdparsingcredits;
          this.subscriptiondetails.balancesmartemailcredits = res.data.pooledbalancesmartemailcredits;
          this.subscriptiondetails.balancetalentpipelinecredits = res.data.pooledbalancetalentpipelinecredits;
        } else {
          if (res.data.teamadmindetails) {
            // Here the logged in person is a Team Member
            this.isteamMember = true
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.teamadmindetails.adminbalancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.teamadmindetails.adminbalancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.teamadmindetails.adminbalancetalentpipelinecredits;
          } else {
            // Here the logged in person is a normal (who does not belong to any team)
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.balancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.balancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.balancetalentpipelinecredits;
          }
        }
        this._localstorageservice.setItem('jdcredits', this.subscriptiondetails.balancejdparsingcredits)
        this._localstorageservice.setItem('tpcredits', this.subscriptiondetails.balancetalentpipelinecredits)
        this._localstorageservice.setItem('cecredits', this.subscriptiondetails.balancecontactenrichmentcredits)
        this._localstorageservice.setItem('secredits', this.subscriptiondetails.balancesmartemailcredits)
      }
  }

  sendmailexpiry(type){
    let data ={
      expiredmetric : type
    }
    this.transactionservice.sendcreditexpirymail(data).subscribe()
  }
  cleverTapEvent(eventName, data) {
   // clevertap.event.push(eventName, data);
    console.log(eventName + " CT event");
  }

  sorttalenpoolList(sorttype) {
    this.sortby = sorttype
    this.selected = false;
    this.getTalentpoolList()
  }

  deleteTalentpoolConfirmation(talent?) {
    if(talent) {
      this.selectedtalentpools.push(talent.talentpoolnumber)
      this.talentdetails = talent
    }

    const confirmRef = this.modalService.open(this.deleteTalentpoolmodal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  deleteTalentpool() {
    let data = {
      talentpoolnumbers: this.selectedtalentpools,
      usernumber: this._localstorageservice.getItem('usernumber')
    }

    this.talentpoolservice.removetalentpoolsinbulk(data).subscribe((res: any) => {
      if (res.status == 'success') {
        this.modalService.dismissAll();
        this.selected = false
        this.successMessage = "Talentpool Deleted Successfully"
        this.toastmessage(this.successMessage, "success")
        this.getTalentpoolList()
       // this.fetchcredits()
        this.selectedtalentpools = []
      }
      else {
        this.errorMessage = "Something Went Wrong"
        this.toastmessage(this.errorMessage, "error")
      }
    })
  }

  route2pricing(){
    this.modalService.dismissAll()
    this.router.navigateByUrl('/subscription/usage')
  }
  /**
   * Delete all talentpools
   * @param talentpool
   * @param value
   */
  selectAll(value) {
    if (value == true) {
      this.selectedtalentpools = []
      this.talentpools.forEach((element, index) => {
        this.talentpools[index].selected = true;
        this.selectedtalentpools.push(element.talentpoolnumber)
        this.selectedTalentpools.push(element);
      })
    } else if (value == false) {
      this.talentpools.forEach((element, index) => {
        this.talentpools[index].selected = false;
        this.selectedtalentpools = []
        this.selectedTalentpools = [];
      })
    }
  }
  /**
   * Delete single talentpool
   * @param talentpool
   * @param value
   */

  checkIfAllSelected(talentpool, value) {
    if (value == true) {
      this.selectedtalentpools.push(talentpool.talentpoolnumber)
      this.selectedTalentpools.push(talentpool);
      if(this.selectedtalentpools.length == this.talentpoolscount) {
        this.selected = true
      }
    } else {
      this.selectedtalentpools = _.without(this.selectedtalentpools, talentpool.talentpoolnumber);
      this.selectedTalentpools = this.selectedTalentpools.filter(tp => tp.talentpoolid != talentpool.talentpoolid);
      this.selected = false
    }
  }
  /**
   * search talentpool name
   * @param event
   */

  searchtalentpools(event) {
    let value = event.target.value
    this.talentpoolname = value
    this.selectedtalentpools = [];
    this.selected = false;
    this.getTalentpoolList()
  }

  triggerTalentpoolSharing(talentpool: any = null, bulkSharing: boolean = false) {
    let selectedTalentpools = [];
    if(!talentpool) {
      if(bulkSharing) {
        selectedTalentpools = selectedTalentpools.concat(this.selectedTalentpools);
      }
    } else {
      selectedTalentpools.push(talentpool);
    }
    const modalRef = this.modalService.open(ShareTalentpoolsModalComponent, { size: 'lg', backdrop: 'static', keyboard: false, centered: true });
    modalRef.componentInstance.selectedTalentpools = selectedTalentpools;
    modalRef.componentInstance.bulkSharing = bulkSharing;
    modalRef.result
    .then((res: any) => {
      if(res === 'user-dismissed') return;
      this.successMessage = res;
    })
    .catch((err: any) => {
      this.errorMessage = err;
    })
    .finally(() => {
        this.talentpools = this.talentpools ? this.talentpools.map(tp => ({ ...tp, selected: false })) : [];
        this.selectedTalentpools = [];
        this.selectedtalentpools = [];
        this.selected = false;
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      });
  }

  /**
   * Edit talentpool details
   * @param talentpool Selected talentpool details
   */
  editTalentpool(talentpool: any) {
    const selectedTalentpoolNumber = talentpool.talentpoolnumber;
    const modalRef = this.modalService.open(CreateTalentpoolComponent, { size: 'lg' as 'lg', backdrop: 'static', keyboard: false ,centered: true,});
    modalRef.componentInstance.TalentpoolIDtoEdit = selectedTalentpoolNumber;
    modalRef.componentInstance.passEntry.subscribe((x: string) => {
      if(x == 'talentpool-edited') {
        this.toastmessage('Talentpool Edited Succesfully', 'success')
        this.fetchcredits()
        this.getTalentpoolList();
      }else if(x == 'notpcredits'){
        this.modalService.open(this.noCreditTalentpool,{ windowClass: "myCustomModalClass", centered: true });
        this.sendmailexpiry('Talent Pipeline credits')
      }else if(x =='error'){
        this.toastmessage('Something went wrong, Please try again in a minute', 'error')
      }
    })
  }

  /**
   * Navigate to similar candidates view
   * @param talentpoolId
   */
  async navigateToSimilarCandidates(talentpoolId: number | string) {
    await this.router.navigate([`/talentpool/details/${talentpoolId}/suggestions`]);
  }

  setPage(index: number) {
    this.start = (index - 1) * Number(this.profilesPerPage);
    if (index == 1) this.currentPage = 1;
    this.getTalentpoolList()
    this.document.documentElement.scrollTop = 0;
  };

  /**
  * Used to change number of profiles on each page
  */
  updatePagePreference() {
    const data = {
      preference_type: 'page-size',
      preference_value: this.profilesPerPage,
      listing_type: 'talentpool-list'
    }

    try {
      this.personSearchService.updatePagePreference(data);
      this.setPage(1);
    } catch {
      this.toastmessage("Something went wrong", 'error');
    }
  }
}


